/*
 * @Author: DQL
 * @Date: 2020-03-20 11:18:19
 * @LastEditors: DQL
 * @LastEditTime: 2023-05-04 16:47:16
 * @Description: file content
 */

/* =============================================
   业务功能路由配置文件引入 Start
  *
  *
*/

// 岗位分类
import roleTypeRoutes from '@/features/system/roleType/roleType.routes.js';

// 岗位维护
import roleRoutes from '@/features/system/role/role.routes.js';

// 机构部门维护
import deptRoutes from '@/features/system/dept/dept.routes.js';

// 用户维护
import userRoutes from '@/features/system/user/user.routes.js';

// 菜单维护
import menuRoutes from '@/features/system/menu/menu.routes.js';

// 权限维护
import permissionRoutes from '@/features/system/permission/permission.routes.js';

// 职位管理
import positionRoutes from '@/features/system/position/position.routes.js';

// 管理员级别维护
import adminLevelManageRoutes from '@/features/system/adminLevelManage/adminLevelManage.routes.js';

// 管理员级别维护
import attrRoutes from '@/features/system/attr/attr.routes.js';

// 扩展字段单身份的用户管理
import singleRoutes from '@/features/system/single/single.routes.js';

// 日志审计
import logRoutes from '@/features/system/log/log.routes.js';

/* 业务功能路由配置文件引入 End */

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/
const FEATURES_ROUTES = [
  roleTypeRoutes, roleRoutes, deptRoutes, userRoutes, menuRoutes, permissionRoutes, logRoutes, positionRoutes, adminLevelManageRoutes, attrRoutes, singleRoutes
];

/* 业务功能路由配置写入 End */

// 路由配置=============================================
const systemRoutes = {
  path: 'system',
  name: 'system',
  component: { template: '<router-view></router-view>' },
  children: [
    ...FEATURES_ROUTES
  ]
};

export default systemRoutes;
